export default "https://assets.egbcdn.net/assets/packs/_/sounds/stream_has_started-5c29470f3b57b43e376d212f4b72e60c.mp3";